/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import Row from "react-bootstrap/Row";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import safetyImg from "../../assets/safety-image.jpg";
import { useAuth } from "../../contexts/AuthContext";
import { getSocket } from "../../Services/Socket";
import PhonePay from "../Payment/Phonepe";
import "./index.css";
import axios from "axios";

const Cart = () => {
  // const [searchParams, setSearchParams] = useSearchParams();

  const {
    cartProducts,
    handleSetCartProducts,
    totalPrice,
    totalDiscount,
    totalMRP,
    selectedProduct,
    handleSelectProduct,
    setSelectedProduct,
    setStep,
    themColor,
    totalExtraDiscount,
    handleCloseCart,
    address,
    showOffset,
    setCartProducts,
  } = useAuth();
  const isAddressAvailable =
    address?.fullname && address?.mobile && address?.city;

  const isCartNotEmpty = cartProducts?.length > 0;
  const [showOffCanvas, setShowOffCanvas] = useState({
    show: false,
    size: false,
    product: {},
  });

  const sizeSectionRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (cartProducts?.length > 0) {
      setSelectedProduct(cartProducts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartProducts]);

  // const location = useLocation();
  // const { fulladdress } = location.state || {};

  // const paramValueGet = () => {
  //   const data = {
  //     amount: searchParams.get("amount"),
  //     name: searchParams.get("name"),
  //     mobile: searchParams.get("mobileno"),
  //     domainname: window.location.hostname,
  //   };
  //   return data;
  // };

  // const handlePaymentFailure = async () => {
  //   const paramData = await paramValueGet();

  //   const failUrl = `${process.env.REACT_APP_GETWAY_URL}/multipayment?paymentstatus=fail&amount=${paramData.amount}&fulladdress=${paramData.name}&mobileno=${paramData.mobile}&domainname=${paramData.domainname}`;
  //   window.location.href = failUrl;
  // };

  // const handlePaymentSuccess = () => {
  //   setLoading(true);
  //   const domainname = window.location.hostname;
  //   const successUrl = `${process.env.REACT_APP_GETWAY_URL}/multipayment?amount=${totalPrice}&name=${fulladdress.fullname}&mobileno=${fulladdress.mobile}&domainname=${domainname}`;
  //   localStorage.setItem("isLoading", true);
  //   window.location.href = successUrl;
  // };

  const handlePaymentSuccess = () => {
    setLoading(true);

    const domainname = window.location.hostname;

    // const successUrl = `${process.env.REACT_APP_GETWAY_URL}/multipayment?amount=${totalPrice}&domainname=${domainname}`;

    let successUrl;

    successUrl = `${process.env.REACT_APP_GETWAY_URL}/multipayment?amount=${totalPrice}&name=${address.fullname}&mobileno=${address.mobile}&domainname=${domainname}`;

    localStorage.setItem("isLoading", true);
    window.location.href = successUrl;
  };

  if (localStorage.getItem("isLoading") === true) {
    setLoading(false);
    localStorage.setItem("isLoading", "");
  }

  // const payNow = async () => {
  //   const paymentStatus = searchParams.get("paymentstatus");
  //   if (paymentStatus === "fail") {
  //     handlePaymentFailure();
  //   } else {
  //     handlePaymentSuccess();
  //   }
  // };

  // For Upi PhonePe Gateway
  const [openPhonePeModal, setOpenPhonePeModal] = useState(false);
  const [loadingPhonePeModal, setLoadingPhonePeModal] = useState(false);
  const [transactionId, setTransactionId] = useState(null);
  const [checkStatusLoading, setCheckStatusLoading] = useState(false);
  const transactionIdRef = useRef(null);
  const intervalRef = useRef(null);
  const lastStatusRef = useRef(null);
  const timeoutRef = useRef(null);
  const intervalDelayRef = useRef(null);
  const attemptCountRef = useRef(0);

  const generateRandomNumberString = (length = 22) => {
    let result = "";
    const digits = "0123456789";
    for (let i = 0; i < length; i++) {
      result += digits.charAt(Math.floor(Math.random() * digits.length));
    }
    return result;
  };

  const storeTransactionWithExpiry = (txnId) => {
    const expiryTime = Date.now() + 45 * 60 * 1000; // 45 minutes in ms
    const data = { txnId, expiry: expiryTime };
    localStorage.setItem("transaction-key", JSON.stringify(data));
  };
  const getValidTransaction = () => {
    const data = JSON.parse(localStorage.getItem("transaction-key"));
    if (!data) return null;

    if (Date.now() > data.expiry) {
      localStorage.removeItem("transaction-key");
      return null;
    }
    return data.txnId;
  };

  useEffect(() => {
    const validTxn = getValidTransaction();
    if (validTxn) {
      setTransactionId(validTxn);
      transactionIdRef.current = validTxn;
    }
  }, []);

  const handlePayNow = () => {
    let existingTxnId = getValidTransaction();
    if (!existingTxnId) {
      existingTxnId = generateRandomNumberString();
      storeTransactionWithExpiry(existingTxnId);
    }
    setTransactionId(existingTxnId);
    transactionIdRef.current = existingTxnId;
    // setOpenPhonePeModal(true);
    setLoadingPhonePeModal(true);
    // After 2 sec, hide spinner and open modal
    setTimeout(() => {
      setLoadingPhonePeModal(false);
      setOpenPhonePeModal(true);
    }, 2000);
  };
  const userAddress = JSON.parse(localStorage.getItem("address"));
  const userProductData = JSON.parse(localStorage.getItem("slectedData"));
  const orderId = "orderId";
  const handleSaveOrderDetails = async () => {
    try {
      const orderData = {
        orderId,
        products: userProductData,
        address: userAddress,
        transitionId: `OM${transactionIdRef.current}Z`,
        amount: totalPrice,
        domainname: window.location.hostname,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/order`,
        orderData
      );

      if (res.status === 201 || res.status === 200) {
        navigate(`/thankyou?txnId=${orderId}`);
      } else {
        navigate("/cart");
      }
    } catch (error) {
      console.error("Order creation failed:", error);
      navigate("/cart");
    }
  };

  const handlePhonePePayment = () => {
    window.location.href = `phonepe://pay?ver=01&mode=19&pa=${process.env.REACT_APP_UPI}&pn=Paying_to_Flipkart&tr=OM${transactionIdRef.current}Z&cu=INR&mc=7446&qrMedium=04&am=${totalPrice}`;

    timeoutRef.current = setTimeout(() => {
      setCheckStatusLoading(true);
    }, 12000);

    attemptCountRef.current = 0;

    intervalDelayRef.current = setTimeout(() => {
      intervalRef.current = setInterval(() => {
        if (attemptCountRef.current < 7) {
          checkPaymentStatus(transactionIdRef.current);
          attemptCountRef.current += 1;
        } else {
          clearInterval(intervalRef.current);
          setCheckStatusLoading(false);
          if (lastStatusRef.current === "success") {
            navigate("/thankyou");
            localStorage.removeItem("transaction-key");
            setOpenPhonePeModal(false);
          } else {
            navigate("/cart");
            localStorage.removeItem("transaction-key");
            setOpenPhonePeModal(false);
          }
        }
      }, 5000);
    }, 7000);
  };

  const checkPaymentStatus = (txnId) => {
    const s = getSocket();
    if (!s) return; // no-op when not "payu"
    s.emit("check-payment-status", { transactionId: `OM${txnId}Z` });
  };

  // Listen to API responses
  useEffect(() => {
    const s = getSocket();
    if (!s) return; // only attach when "payu"

    const onStatus = async (data) => {
      lastStatusRef.current = data?.status;
      if (data?.status === "success") {
        clearInterval(intervalRef.current);
        await handleSaveOrderDetails();
        setOpenPhonePeModal(false);
        setCheckStatusLoading(false);
      }
    };

    s.on("payment-status-response", onStatus);
    return () => s.off("payment-status-response", onStatus);
  }, [transactionId]);

  // Watch for canvas close and send request only once
  useEffect(() => {
    if (
      process.env.REACT_APP_PAYMENT_TYPE === "payu" &&
      !openPhonePeModal &&
      transactionId
    ) {
      checkPaymentStatus(transactionIdRef.current);
    }
  }, [openPhonePeModal, transactionId]);

  const payNow = async () => {
    let hasError = false;

    const updatedCart = cartProducts.map((product) => {
      let productError = false;

      if (product?.sizes?.length > 0) {
        product.sizes.forEach((group) => {
          if (!product?.selectedSizes?.[group.type]) {
            productError = true;
            hasError = true;
          }
        });
      }

      return { ...product, sizeError: productError };
    });

    handleSetCartProducts(updatedCart);

    if (hasError) {
      sizeSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }
    const randomTxnId = Math.floor(10000000 + Math.random() * 90000000);
    if (process.env.REACT_APP_PAYMENT_TYPE === "cod") {
      navigate(`/thankyou?txnId=${randomTxnId}`);
      handleCloseCart();
    } else if (process.env.REACT_APP_PAYMENT_TYPE === "upi") {
      handlePayNow();
    } else {
      handlePaymentSuccess();
    }
  };

  localStorage.setItem("totalPrice", totalPrice);

  const handleDecrement = (selectItem, quantity) => {
    if (quantity < 1) return; // prevent 0 or negative
    updateCartProduct(selectItem, quantity);
  };

  const handleIncrement = (selectItem, quantity) => {
    updateCartProduct(selectItem, quantity);
  };

  const updateCartProduct = (selectItem, quantity) => {
    const updatedProduct = { ...selectItem, quantity };
    const updatedCart = cartProducts.map((item) =>
      item._id === updatedProduct._id ? updatedProduct : item
    );
    handleSetCartProducts(updatedCart);
    setSelectedProduct(updatedCart);
  };

  const [mediaQuery, setMediaQuery] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setMediaQuery(window.innerWidth < 400);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (cartProducts?.length > 0) {
      let updated = false;

      const updatedCart = cartProducts.map((product) => {
        if (product.sizes?.length > 0 && !product.selectedSizes) {
          updated = true;
          const defaultSelected = {};
          product.sizes.forEach((group) => {
            if (group.options?.length > 0) {
              defaultSelected[group.type] = group.options[0]; // 👈 pick first option
            }
          });
          return {
            ...product,
            selectedSizes: defaultSelected,
            sizeError: false,
          };
        }
        return product;
      });

      if (updated) {
        handleSetCartProducts(updatedCart);
        setSelectedProduct(updatedCart); // 👈 keep in sync
      }
    }
  }, [cartProducts]);

  if (loading || loadingPhonePeModal) {
    return (
      <div
        className="d-flex justify-content-center align-items-center position-absolute"
        style={{
          width: "100%",
          height: "100vh",
          flexDirection: "column",
          top: 0,
          right: 0,
          left: 0,
          background: "#fff",
          zIndex: 9999,
          bottom: 0,
        }}
      >
        <Spinner />
        <div>Please wait</div>
      </div>
    );
  }

  return (
    <Container className="h-100 d-flex flex-column justify-content-between">
      {isAddressAvailable && isCartNotEmpty && (
        <div className="addressBlocks-base-finalAddress border">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5>Deliver to:</h5>
            </div>
            <div>
              <Button
                className="addressBlocks-base-changeOrAddBtn w-30 p-1 m-0"
                variant="outline-secondary"
                onClick={() => {
                  navigate("/checkout/address", {
                    state: { routeChange: true, showAddressForm: true },
                  });
                  handleCloseCart();
                }}
              >
                CHANGE
              </Button>
            </div>
          </div>
          <div>
            <div className="">
              <div className="fs-6">
                <span className="fw-bold">Name:-</span> {address?.fullname}
              </div>
            </div>
            <div className="">
              <div>
                <span className="fw-bold">Address As :-</span> {address?.city},{" "}
                {address?.address1} , {address?.address2} , {address?.pincode}
              </div>
              <div className="addressDetails-base-mobile">
                <span className="fw-bold">Mobile: </span>
                {address?.mobile}
              </div>
            </div>
          </div>
        </div>
      )}
      <div>
        {cartProducts?.length === 0 && (
          <Row>
            <Col>
              <div
                style={{
                  padding: "10px",
                  marginTop: "20px",
                  borderRadius: "15px",
                  width: "100%",
                  minHeight: "250px",
                  display: "flex",
                  border: "1px solid black",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Outline"
                    viewBox="0 0 24 24"
                    width="50"
                    height="50"
                  >
                    <path d="M21,6H18A6,6,0,0,0,6,6H3A3,3,0,0,0,0,9V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V9A3,3,0,0,0,21,6ZM12,2a4,4,0,0,1,4,4H8A4,4,0,0,1,12,2ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V9A1,1,0,0,1,3,8H6v2a1,1,0,0,0,2,0V8h8v2a1,1,0,0,0,2,0V8h3a1,1,0,0,1,1,1Z" />
                  </svg>
                </div>
                <h2
                  className="mt-3"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  Your cart is empty
                </h2>
                <div className="Footer__Content Rte">
                  Let's go Buy Somthing!
                </div>
                <Button
                  variant="dark"
                  className="btn my-3 primary d-flex justify-content-center align-items-center ripple animated"
                  style={{
                    padding: "10px 20px",
                    background: "var(--them-color)",
                    borderColor: "var(--them-color)",
                  }}
                  onClick={(e) => {
                    e?.target?.classList?.add("bounceIn");
                    navigate(`/`);
                    handleCloseCart();
                    setTimeout(() => {
                      if (e?.target?.classList?.contains("bounceIn"))
                        e?.target?.classList?.remove("bounceIn");
                    }, 1000);
                  }}
                >
                  Shop Now
                </Button>
              </div>
            </Col>
          </Row>
        )}
        {cartProducts?.length > 0 && (
          <Row>
            <Col
              md={12}
              xs={12}
              style={{
                fontWeight: "bold",
                fontSize: 13,
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
                marginTop: 10,
              }}
            >
              {" "}
              <span style={{ fontSize: "16px" }}>
                <Form.Check
                  className="custom-check-box d-flex"
                  type={"checkbox"}
                  checked={selectedProduct?.length > 0}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (selectedProduct?.length > 0) {
                      setSelectedProduct([]);
                    } else {
                      setSelectedProduct(cartProducts);
                    }
                  }}
                />
              </span>
              <span className="ms-2">{`${selectedProduct?.length || 0}/${cartProducts?.length || 0
                } ITEMS SELECTED`}</span>
              <span
                style={{
                  color: "#ff4e4e",
                  marginLeft: "5px",
                }}
              >
                ₹{totalPrice}
              </span>
            </Col>
          </Row>
        )}
        <Row className="g-2">
          {cartProducts?.map((item) => (
            <Col key={item._id} xs={12} md={12}>
              <Card
                className="flex-row align-items-center position-relative"
                onClick={() => {
                  handleCloseCart();
                }}
              >
                <div
                  className="product-select-box "
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectProduct(item._id);
                  }}
                >
                  <Form.Check
                    className="custom-check-box d-flex"
                    type={"checkbox"}
                    checked={selectedProduct?.find((o) => o._id === item._id)}
                  />
                </div>
                <div
                  className="product-delete-box"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (selectedProduct?.find((o) => o._id === item._id)) {
                      handleSelectProduct(item._id);
                    }
                    const selectedItem = cartProducts.filter(
                      (o) => o._id !== item._id
                    );
                    handleSetCartProducts(selectedItem);
                  }}
                >
                  <MdDelete size={22} color="red" />
                </div>
                <div
                  onClick={() => navigate(`/single-product/${item._id}`)}
                  style={{
                    minWidth: 120,
                    maxWidth: 120,
                    width: "100%",
                    maxHeight: 260,
                    height: "100%",
                    padding: 10,
                    borderRadius: 6,
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={item?.images?.[0]}
                    style={{
                      height: "100%",
                      minWidth: "100%",
                      borderRadius: "6px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <Card.Body
                  className={mediaQuery ? "ps-0 text-start" : " text-start"}
                >
                  {/* <Card.Body style={{ textAlign: "start" }}> */}
                  <Card.Subtitle
                    onClick={() => navigate(`/single-product/${item._id}`)}
                    className="text-ellips"
                  >
                    {item.title}
                  </Card.Subtitle>
                  <Card.Text className="d-flex align-items-center mt-2 mb-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill="#FF3F6C"
                        d="M7.998 4c-2.674 0-5.1 1.57-6.888 4.12a.625.625 0 000 .709c1.789 2.552 4.214 4.122 6.888 4.122 2.674 0 5.099-1.57 6.888-4.12a.629.629 0 000-.709C13.096 5.57 10.672 4 7.998 4zm.192 7.627c-1.775.12-3.241-1.45-3.13-3.357.092-1.573 1.28-2.848 2.746-2.946 1.775-.12 3.24 1.45 3.13 3.357-.095 1.57-1.283 2.845-2.746 2.946zm-.09-1.456c-.955.064-1.746-.78-1.683-1.806.05-.848.69-1.533 1.48-1.588.957-.065 1.747.78 1.684 1.806-.051.85-.693 1.536-1.48 1.588z"
                      ></path>
                    </svg>
                    <span
                      className=""
                      style={{
                        fontSize: "12px",
                        fontWeight: 700,
                        paddingLeft: "3px",
                        color: "#282c3f",
                      }}
                    >
                      {Math.floor(Math.random() * 31) + 50}
                    </span>
                    <span
                      className=""
                      style={{
                        color: "#94969f",
                        fontSize: "12px",
                        paddingLeft: "3px",
                      }}
                    >
                      People viewing now
                    </span>
                  </Card.Text>
                  <Card.Text className="mt-1 mb-0">
                    <div
                      className={`product-size ${item?.size?.length > 0
                        ? "d-flex flex-wrap justify-content-between align-items-center "
                        : "my-2"
                        }  mt-2`}
                    >
                      <div>
                        {item?.sizes?.length > 0 && (
                          <div
                            className="itemComponents-base-quantity me-2"
                            onClick={(e) => {
                              e?.stopPropagation();
                              setShowOffCanvas((prev) => ({
                                show: !prev.show,
                                size: true,
                                product: item,
                              }));
                            }}
                            ref={sizeSectionRef}
                          >
                            <span className="">
                              Size:{" "}
                              {item?.selectedSizes
                                ? Object.entries(item.selectedSizes)
                                  .map(([type, value]) => `${value}`)
                                  .join(", ")
                                : "Not selected"}
                            </span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="3"
                              viewBox="0 0 6 3"
                              className="itemComponents-base-dropDown mx-1"
                            >
                              <path fillRule="evenodd" d="M0 0h6L3 3z"></path>
                            </svg>
                          </div>
                        )}
                        {item.sizeError &&
                          item?.sizes?.some(
                            (g) => !item?.selectedSizes?.[g.type]
                          ) && (
                            <p
                              style={{
                                color: "red",
                                fontSize: "14px",
                                marginTop: "5px",
                              }}
                            >
                              Please select size
                            </p>
                          )}
                      </div>
                      <div
                        className="toggle-amount mt-2"
                        style={{
                          border: `1px solid ${process.env.REACT_APP_THEAM_COLOR}`,
                        }}
                      >
                        <div>
                          <i
                            className="fa-solid fa-minus"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDecrement(item, item.quantity - 1 || 0);
                            }}
                          ></i>
                        </div>
                        <div className="amount">{item.quantity || 1}</div>
                        <div>
                          <i
                            className="fa-solid fa-plus"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleIncrement(item, item.quantity + 1 || 1);
                            }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </Card.Text>
                  {item?.price &&
                    (item?.discount ? (
                      <Card.Text style={{ textAlign: "left" }} className="mb-0">
                        <span style={{ fontWeight: 700 }}>
                          ₹{item?.discount}
                        </span>
                        <span
                          style={{
                            color: "#8d8d8d",
                            marginLeft: "5px",
                          }}
                        >
                          MRP
                        </span>
                        <span
                          style={{
                            color: "#8d8d8d",
                            marginLeft: "5px",
                            textDecoration: "line-through",
                          }}
                        >
                          ₹{item.price}
                        </span>
                        <span
                          style={{
                            wordBreak: "break-all",
                            color: "#ff4e4e",
                            marginLeft: "5px",
                          }}
                        >
                          {`(${(
                            ((item?.price - item.discount) / item?.price) *
                            100
                          ).toFixed(0)})% OFF`}
                        </span>
                      </Card.Text>
                    ) : (
                      <Card.Text style={{ textAlign: "left" }} className="mb-0">
                        {item.price}
                      </Card.Text>
                    ))}
                  {/* {window.location.pathname === "/cart" && (
                    <Card.Text
                      style={{ textAlign: "left" }}
                      className="mb-0 mt-2"
                    >
                      <span className="me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="8"
                          viewBox="0 0 10 8"
                          fill="#03a685"
                        >
                          <path
                            fillRule="evenodd"
                            d="M9.775.227A.716.716 0 0 0 8.716.24L3.373 6.015a.09.09 0 0 1-.133 0L1.278 3.91a.716.716 0 0 0-1.059-.001.834.834 0 0 0 0 1.127l2.565 2.742c.14.15.33.223.53.223h.004a.71.71 0 0 0 .53-.23l5.939-6.416A.833.833 0 0 0 9.775.227"
                          ></path>
                        </svg>
                      </span>
                      <span className="fs-6 me-1">Delivery between</span>
                      <span className="fs-6 fw-semibold">
                        {`${new Date(
                          Date.now() + 5 * 24 * 60 * 60 * 1000
                        ).getDate()} ${new Date(
                          Date.now() + 5 * 24 * 60 * 60 * 1000
                        ).toLocaleString("default", { month: "short" })}`}{" "}
                        -{" "}
                        {`${new Date(
                          Date.now() + 8 * 24 * 60 * 60 * 1000
                        ).getDate()} ${new Date(
                          Date.now() + 8 * 24 * 60 * 60 * 1000
                        ).toLocaleString("default", { month: "short" })}`}
                      </span>
                    </Card.Text>
                  )} */}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {cartProducts?.length > 0 && (
          <div className="mt-4">
            <div>
              <h6 className="card-title text-start fw-bold border-bottom pb-2 pt-2">{`PRICE DETAILS (${selectedProduct?.length === 1
                ? "1 Item"
                : `${selectedProduct?.length} Items`
                })`}</h6>
              <div className="mt-3">
                <div className="d-flex flex-row justify-content-between align-items-center ">
                  <span>Total MRP</span>
                  <span className="ms-2">
                    <span>
                      <span className="">₹</span>
                      {totalMRP}
                    </span>
                  </span>
                </div>
                {totalDiscount ? (
                  <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                    <span>Discount on MRP</span>
                    <span className="ms-2 text-success">
                      <span>
                        - <span className="">₹</span>
                        {totalDiscount}
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {totalExtraDiscount ? (
                  <>
                    <div className="d-flex flex-row justify-content-between align-items-center mt-2 border-top pt-2">
                      <span>Total Price</span>
                      <span className="ms-2">
                        <span>
                          <span className="">₹</span>
                          {totalMRP - totalDiscount}
                        </span>
                      </span>
                    </div>
                    <div className="d-flex flex-row justify-content-between align-items-center mt-2 ">
                      <span>Coupon Applied (Buy 2 Get 1 free)</span>
                      <span className="ms-2 text-success">
                        <span>
                          -<span className="">₹</span>
                          {totalExtraDiscount}
                        </span>
                      </span>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="d-flex flex-row justify-content-between align-items-center mt-2 fw-bold border-top pt-3">
                  <span>Total Amount</span>
                  <span className="ms-2">
                    <span>
                      <span className="">₹</span>
                      {totalPrice}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div>
          <Offcanvas
            show={showOffCanvas.show}
            onHide={(e) => {
              e?.stopPropagation();
              setShowOffCanvas((prev) => ({
                ...prev,
                show: !prev.show,
                product: {},
              }));
            }}
            placement={"bottom"}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                Select {showOffCanvas.size ? "Size" : "Quantity"}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div
                className="d-flex flex-column gap-3"
                style={{ overflowX: "auto" }}
              >
                {showOffCanvas.size ? (
                  showOffCanvas?.product?.sizes?.map((group, idx) => (
                    <div key={idx}>
                      <p style={{ fontWeight: 600, marginBottom: "8px" }}>
                        Select {group.type}
                      </p>
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        {group.options.map((option, index) => (
                          <span
                            key={index}
                            onClick={(e) => {
                              e?.stopPropagation();

                              // 🔧 CHANGE: update selectedSizes inside offcanvas local product
                              // and also compute "sizeError" live for this offcanvas product
                              setShowOffCanvas((prev) => {
                                const nextSelected = {
                                  ...(prev.product.selectedSizes || {}),
                                  [group.type]: option,
                                };

                                // check if all required groups are selected
                                const isIncomplete = (
                                  prev.product?.sizes || []
                                ).some((g) => !nextSelected?.[g.type]);

                                return {
                                  ...prev,
                                  product: {
                                    ...prev.product,
                                    selectedSizes: nextSelected,
                                    // 🔧 CHANGE: keep an up-to-date sizeError on the temp product
                                    sizeError: isIncomplete,
                                  },
                                };
                              });
                            }}
                            style={{
                              height: "25px",
                              width: option.length > 4 ? "auto" : "25px",
                              borderRadius: 6,
                              cursor: "pointer",
                              border: "1px solid black",
                              padding: "20px",
                              background:
                                showOffCanvas?.product?.selectedSizes?.[
                                  group.type
                                ] === option
                                  ? themColor
                                  : "#fff",
                              color:
                                showOffCanvas?.product?.selectedSizes?.[
                                  group.type
                                ] === option
                                  ? "#fff"
                                  : "#000",
                            }}
                            className="d-flex justify-content-center align-items-center mx-1"
                          >
                            {option}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  // ✅ Handle quantity selection
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    {Array.from({ length: 5 }, (_, k) => k + 1).map((item) => (
                      <span
                        key={item}
                        onClick={(e) => {
                          e?.stopPropagation();
                          setShowOffCanvas((prev) => ({
                            ...prev,
                            product: { ...prev.product, quantity: item },
                          }));
                        }}
                        style={{
                          height: "25px",
                          width: "25px",
                          borderRadius: 6,
                          cursor: "pointer",
                          border: "1px solid black",
                          padding: "20px",
                          background:
                            showOffCanvas?.product?.quantity === item
                              ? themColor
                              : "#fff",
                          color:
                            showOffCanvas?.product?.quantity === item
                              ? "#fff"
                              : "#000",
                        }}
                        className="d-flex justify-content-center align-items-center mx-1"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Price Section */}
              <div className="mt-4 mb-3">
                {showOffCanvas?.product?.price &&
                  (showOffCanvas?.product?.discount ? (
                    <p style={{ textAlign: "left" }} className="mb-0">
                      <span style={{ fontWeight: 700 }}>
                        ₹{showOffCanvas?.product?.discount}{" "}
                      </span>
                      <span style={{ color: "#8d8d8d", marginLeft: "5px" }}>
                        MRP
                      </span>
                      <span
                        style={{
                          color: "#8d8d8d",
                          marginLeft: "5px",
                          textDecoration: "line-through",
                        }}
                      >
                        ₹{showOffCanvas?.product?.price}
                      </span>
                      <span
                        style={{ color: "#ff4e4e", marginLeft: "5px" }}
                      >{`(${(
                        ((showOffCanvas?.product?.price -
                          showOffCanvas?.product.discount) /
                          showOffCanvas?.product?.price) *
                        100
                      ).toFixed(0)})% OFF`}</span>
                    </p>
                  ) : (
                    <p style={{ textAlign: "left" }} className="mb-0">
                      ₹{showOffCanvas?.product?.price}
                    </p>
                  ))}
              </div>

              {/* Done Button */}
              <Button
                onClick={(e) => {
                  e?.stopPropagation();
                  const updatedProduct = { ...showOffCanvas?.product };
                  const hasMissing = (updatedProduct?.sizes || []).some(
                    (g) => !updatedProduct?.selectedSizes?.[g.type]
                  );
                  updatedProduct.sizeError = hasMissing;
                  const oldData = cartProducts.map((it) => {
                    if (it._id === updatedProduct?._id) {
                      return updatedProduct;
                    }
                    return it;
                  });

                  handleSetCartProducts(oldData);
                  setSelectedProduct(oldData);

                  setShowOffCanvas((prev) => ({
                    ...prev,
                    show: !prev.show,
                    product: {},
                  }));
                }}
                variant="dark"
                style={{
                  background: themColor,
                  borderColor: themColor,
                  width: "100%",
                  padding: "10px",
                }}
              >
                Done
              </Button>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
      {cartProducts?.length > 0 && (
        <div className="position-sticky bottom-0 pb-3 bg-white">
          <div
            className="mb-2"
            style={{
              backgroundColor: "#fff6f4",
              fontSize: "12px",
              padding: "4px 0 5px",
              textAlign: "center",
              fontWeight: 700,
              color: "#282c3f",
            }}
          >
            {selectedProduct?.length
              ? `${selectedProduct?.length === 1
                ? "1 Item"
                : `${selectedProduct?.length} Items`
              } selected for order`
              : "No Item selected, select at least one item to place order."}
          </div>

          {isAddressAvailable ? (
            <Button
              variant="dark"
              style={{
                width: "100%",
                padding: "10px",
                background: process.env.REACT_APP_THEAM_COLOR,
                borderColor: process.env.REACT_APP_THEAM_COLOR,
              }}
              disabled={selectedProduct?.length === 0}
              onClick={() => {
                if (
                  showOffset &&
                  process.env.REACT_APP_PAYMENT_TYPE === "upi"
                ) {
                  handleCloseCart();
                  navigate("/cart");
                } else {
                  payNow();
                }
              }}
            >
              {process.env.REACT_APP_PAYMENT_TYPE !== "upi"
                ? "Pay Now"
                : "Continue"}
            </Button>
          ) : (
            <Button
              style={{
                width: "100%",
                padding: "10px",
                background: process.env.REACT_APP_THEAM_COLOR,
                borderColor: process.env.REACT_APP_THEAM_COLOR,
              }}
              disabled={selectedProduct?.length === 0}
              onClick={(e) => {
                e.stopPropagation();
                setStep(2);
                handleCloseCart();
                navigate("/checkout/address");
              }}
            >
              Place Order
            </Button>
          )}
        </div>
      )}
      <div className="mt-4">
        <img src={safetyImg} style={{ width: "100%" }} alt="" />
      </div>
      {openPhonePeModal && (
        <PhonePay
          title="Select Payment Method"
          open={openPhonePeModal}
          amount={totalPrice}
          onClose={() => {
            clearTimeout(timeoutRef.current);
            clearTimeout(intervalDelayRef.current);
            clearInterval(intervalRef.current);
            setOpenPhonePeModal(false);
            setCheckStatusLoading(false);
          }}
          handlePhonePePayment={handlePhonePePayment}
          checkStatusLoading={checkStatusLoading}
        />
      )}
    </Container>
  );
};

export default Cart;
